export interface BlogItem {
  _id: string;
  blogId: string;
  title: string;
  description: string;
  slug: string;
  banner: string;
  createdAt: string;
  updatedAt?: string;
  authorName?: string;
  authorImage?: string;
  category?: string;
  readTime?: string;
}

export const FALLBACK_BLOGS: BlogItem[] = [
  {
    _id: "blog-1",
    blogId: "everest-base-camp-guide-2025",
    title: "Complete Guide to Everest Base Camp Trek: Tips, Routes & Essentials",
    description:
      "Embarking on the trek to Everest Base Camp is a dream for adventurers worldwide. Discover step-by-step preparation tips, acclimatization schedules, and hidden scenic spots along the legendary Solukhumbu trail.",
    slug: "everest-base-camp-guide-2025",
    banner:
      "https://images.unsplash.com/photo-1544735716-392fe2489ffa?q=80&w=1200&auto=format&fit=crop",
    createdAt: new Date(Date.now() - 3 * 86400000).toISOString(),
    authorName: "Prem Gurung",
    authorImage: "/Guides/Guide.jpg",
    category: "Trekking Guide",
    readTime: "6 min read",
  },
  {
    _id: "blog-2",
    blogId: "essential-mountaineering-gear-checklist",
    title: "Essential Gear Checklist for High-Altitude Himalayan Expeditions",
    description:
      "Scaling 6,000m+ peaks requires uncompromising gear reliability. From technical crampons and harness selection to triple-layer thermal insulation, here is your ultimate Himalayan expedition packing checklist.",
    slug: "essential-mountaineering-gear-checklist",
    banner:
      "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=1200&auto=format&fit=crop",
    createdAt: new Date(Date.now() - 7 * 86400000).toISOString(),
    authorName: "Lakpa Sherpa",
    authorImage: "/Guides/Guide.jpg",
    category: "Mountaineering",
    readTime: "8 min read",
  },
  {
    _id: "blog-3",
    blogId: "annapurna-circuit-best-time-to-visit",
    title: "Why Annapurna Circuit Remains Nepal's Most Scenic Classic Trek",
    description:
      "Traversing diverse ecosystems from subtropical paddy fields to Thorong La Pass at 5,416 meters, explore why the Annapurna Circuit delivers an unmatched cultural and alpine adventure.",
    slug: "annapurna-circuit-best-time-to-visit",
    banner:
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb?q=80&w=1200&auto=format&fit=crop",
    createdAt: new Date(Date.now() - 14 * 86400000).toISOString(),
    authorName: "Prem Gurung",
    authorImage: "/Guides/Guide.jpg",
    category: "Expedition Tips",
    readTime: "5 min read",
  },
];
